import { gql, TypedDocumentNode } from "@apollo/client";

import { StackVendor, StackVendorMigrationInput, InputMaybe } from "types/generated";

type MigrateAllStacksVendorResult = {
  migrated: number;
  left: number;
};

type MigrateAllStacksVendorData = {
  stackMigrateVendorAll: MigrateAllStacksVendorResult;
};

type MigrateAllStacksVendorArgs = {
  targetVendor: StackVendor;
  config?: InputMaybe<StackVendorMigrationInput>;
};

export const MIGRATE_ALL_STACKS_VENDOR: TypedDocumentNode<
  MigrateAllStacksVendorData,
  MigrateAllStacksVendorArgs
> = gql`
  mutation MigrateAllStacksVendor(
    $targetVendor: StackVendor!
    $config: StackVendorMigrationInput
  ) {
    stackMigrateVendorAll(targetVendor: $targetVendor, config: $config) {
      migrated
      left
    }
  }
`;
